import React, { useEffect, useState } from "react";
import Loading from "../../../loading/LoadingPage";
import { TitleContainer, Wrapper } from "../../style";
import ColumnContainer from "../../../common/ColumnContainer";
import { Typography } from "@mui/material";
import SingleFaq from "./SingleFaq";
import { useDispatch } from "react-redux";
import { getFaqs } from "../../../../redux/features/faq/faqSlice";
import "./FaqPage.less";
import { useGetFaqsByAdminIdQuery } from "../../../../redux/features/faq/faqApi";
import { useAuth } from "../../../../utils/hooks/useAuth";
import { FormattedMessage } from "react-intl";

export default function UserFaqPage() {
  //INIT
  const dispatch = useDispatch();
  const auth = useAuth();
  const adminId = auth?.auth?.userData?.admin_id;

  // STATE

  //REDUX
  const { data, isSuccess, isLoading, isError } = useGetFaqsByAdminIdQuery({
    adminId: adminId,
  });

  // EFFECTS
  useEffect(() => {
    if (isSuccess) {
      dispatch(getFaqs(data));
    }
  }, [isSuccess, data, dispatch]);

  return (
    <Wrapper>
      <ColumnContainer start style={{ height: "100vh" }} className="faq-page">
        <ColumnContainer>
          <TitleContainer>
            <Typography variant="h3" component="h3">
              <FormattedMessage id="faq.title" />
            </Typography>
          </TitleContainer>
        </ColumnContainer>
        <ColumnContainer halfGap>
          {isSuccess && data?.length > 0 ? (
            data?.map((faq, index) => (
              <SingleFaq index={index} key={index} item={faq} />
            ))
          ) : isSuccess && data?.length === 0 ? (
            <Typography variant="h6" component="h6">
              Nessuna FAQ presente
            </Typography>
          ) : isLoading ? (
            <Loading />
          ) : isError ? (
            <Typography variant="h6" component="h6">
              Error
            </Typography>
          ) : null}
        </ColumnContainer>
      </ColumnContainer>
    </Wrapper>
  );
}
